import { render } from "./NavbarCompThird.vue?vue&type=template&id=9a4ddd88"
import script from "./NavbarCompThird.vue?vue&type=script&lang=js"
export * from "./NavbarCompThird.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__